import store, {connect} from '@/store/simple_store';
import {KEYS} from '@/store/index';

function setStoreData(key: string, data: any) {
    const limitKeys = [KEYS.CUR_DOCUMENT, KEYS.USER];
    if (limitKeys.includes(key)) {
        console.error('禁止在插件中修改核心store数据，keyName：', key);
        return;
    }

    store.setData(key, data);
}

export default {
    connect,
    storeKeys: KEYS,
    storeData: store.data,
    setStoreData: setStoreData.bind(store),
    getStoreData: store.getData.bind(store),
};
